import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { Carrier, } from 'src/app/shared/common-components/common-structure';
import { system_admin } from '../../shared/common-components/AppConstants';
import * as _ from 'lodash';
import { LoadingService } from 'src/app/services/loading/loading.service';
import { AlertService } from 'src/app/services/alert/alert.service';
import { HhgScopeService } from '../../services/hhg-scope/hhg-scope.service';
import { CarrierService } from 'src/app/services/carrier/carrier.service';
import { UserService } from '../../services/user/user.service';
import { User } from '../../services/user/user';
import { DownloadFileResponse } from 'src/app/shared/common-components/file-storage/downloadFileResponse';
import * as FileSaver from 'file-saver';
import { api_error, hhg_scope_download_success } from '../../shared/common-components/AppConstants';
import {ColDef, ColGroupDef, GridOptions} from 'ag-grid-community';
import { StateCountryService } from 'src/app/services/state-country/state-country.service';
import { map, shareReplay } from 'rxjs/operators';


@Component({
    selector: 'app-hhg-scope-report-download',
    templateUrl: './hhg-scope-report-download.component.html',
    styleUrls: ['./hhg-scope-report-download.component.css'],
    standalone: false
})
export class HhgScopeReportDownloadComponent implements OnInit {
  hhgScopeReportForm: UntypedFormGroup;
  carrierList: Carrier[];
  hhgScopeResultsGridOptions: GridOptions = this.initializeGridOptions();
  private gridApi;
  public overlayNoRowsTemplate;
  hhgScopeReportList: any = [];
  columnDefs: any;

  controlId: string;
  carrierId: string;
  scopeType: string;
  status: string;
  carrierIdList: any[];
  businessTypeList: string[];

  private tmssloader;
  showExport = false;
  scacChanged = false;
  sroChanged = false;
  scopeTypeChanged = false;
  showScasList = true;
  currentUser: User | any;
  scopeTypeList: any[] = [
    { name: 'Interstate', value: 'Interstate' },
    { name: 'Intrastate', value: 'Intrastate' },
    { name: 'International', value: 'International' }
  ];
  stateCountries$ = this.stateCountryService.getAll().pipe(map(results => results.sort(
    (x,y) =>x.stateCountryName < y.stateCountryName ? -1 : 1)),shareReplay(1));

  states$ = this.stateCountries$.pipe(map((results) => results.filter(state => (state.stateCountryType === 'State') &&
                                                                     (state.parentCountryId === 326))
                                                                     .filter(state => state.stateCountryCode !== 'HI')
                                                                     .filter(state => state.stateCountryCode !== 'AK')
                                                                     .filter(state => state.stateCountryCode !== 'PR')), shareReplay(1));
  interStates$ = this.stateCountries$.pipe(map((results) => results.filter(state => (state.stateCountryType === 'State')) 
                                                                     .filter(state => state.stateCountryCode !== 'HI')
                                                                     .filter(state => state.stateCountryCode !== 'AK')
                                                                     .filter(state => state.stateCountryCode !== 'PR')), shareReplay(1));
  serviceAreas$ = this.stateCountries$.pipe(map((results) => results.
             filter(state => state.stateCountryType === 'Service Area' &&
                             (state.stateCountryCode !== '0000') && 
                             (state.stateCountryCode !== '2302') &&
                             (state.stateCountryCode !== '2305'))
                             .sort((x,y) =>x.stateCountryCode < y.stateCountryCode ? -1 : 1)), shareReplay(1));
  countries$ = this.stateCountries$.pipe(map((results) => results.filter(state => state.stateCountryType === 'Country')), shareReplay(1));
  statesAndCountries$ = this.stateCountries$.pipe(map((results) => results.
              filter((state => state.stateCountryType === 'State' ||
                               state.stateCountryType === 'Country'))
                               .filter(state => state.stateCountryCode !== 'HI')
                               .filter(state => state.stateCountryCode !== 'AK')), shareReplay(1));
 origin$: any;
 destination$: any;
 originId: number;
 destinationId: number;
 allScacsSelected: boolean;
 allOriginSelected: boolean;
 allDestinationSelected: boolean;
 disableBtn: boolean;
 showIntlMsg: boolean;
 showIntraMsg: boolean;

  constructor(private fb: UntypedFormBuilder,
    private hhgScopeService: HhgScopeService,
    private carrierService: CarrierService,
    private userService: UserService,
    public loader: LoadingService,
    private alertService: AlertService,
    private stateCountryService: StateCountryService) {

  }
  /**
   * initializing the grid
   */
  private initializeGridOptions() {
    return <GridOptions>{
      rowSelection: 'multiple',
      defaultColDef: {
        sortable: true,
        resizable: true,
        filter: 'agTextColumnFilter',
        filterParams: {
          suppressAndOrCondition: true
        }
      },
      headerHeight: 50,
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      onGridReady: params => {
        this.gridApi = params.api;
        params.api.sizeColumnsToFit();
      },
      overlayLoadingTemplate:
        '<span class="ag-overlay-loading-center">Please wait while your rows are loading</span>'
    };
  }

  getHHGScopeResultColumnDefs(): (ColDef | ColGroupDef)[] {
    return [
      <ColDef>
        {
          headerName: 'SCAC',
          field: 'scac',
          filter: 'agTextColumnFilter',
        },
      {
        headerName: 'Origin',
        field: 'origin',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Destination',
        field: 'destination',
        filter: 'agTextColumnFilter'
      },
      {
        headerName: 'Scope Type',
        field: 'scopeType',
        filter: 'agTextColumnFilter'
      }
    ];
  }

  ngOnInit() {
    this.columnDefs = this.getHHGScopeResultColumnDefs();
    this.createForm();
    this.tmssloader = this.loader;
    // this.populateCurrentUser();
    // If user role is System Admin show the Scac list, otherwise hide it.
    this.showScasList = true;
    this.populateScacDropdown();
  }

  createForm() {
    this.hhgScopeReportForm = this.fb.group({
      scac: new UntypedFormControl(''),
      scopeTypeSelect: new UntypedFormControl(''),
      origin: new UntypedFormControl(''),
      destination: new UntypedFormControl('')
    });
  }

  // populate the  HHG Scac multiple selected list by Business Type(HHG or HHG & FRT) and Status (Active)
  populateScacDropdown() {
    this.tmssloader.show();
    this.businessTypeList = [];
    this.businessTypeList.push('HHG', 'HHG & FRT');
    this.status = 'Active';
    this.carrierService.getAllSmallCarrierListByBusinessTypeAndStatus(this.businessTypeList, this.status).subscribe(carrierList => {
      this.carrierList = carrierList;
      this.tmssloader.hide();
    }, error => {
      this.tmssloader.hide();
      this.alertService.error('There was an error retrieving Scac List');
    });
    this.scacChanged = false;
    this.originId = -1;
    this.destinationId = -1;
    this.allOriginSelected = true;
    this.allDestinationSelected = true;
    this.disableBtn = true;
    this.showIntlMsg = false;
    this.showIntraMsg = false;
  }
  scopeTypeChange(scopeType: string) {
    this.scopeType = scopeType;
    this.scopeTypeChanged = true;
    this.hhgScopeReportForm.get('origin').setValue('-1');
    this.allOriginSelected = true;
    this.hhgScopeReportForm.get('destination').setValue('-1');
    this.allDestinationSelected = true;
    this.showIntlMsg = false;
    this.showIntraMsg = false;
    if(scopeType === 'International'){
      this.origin$ = this.statesAndCountries$;
      this.destination$ = this.statesAndCountries$;
      if(this.allScacsSelected){
        this.showIntlMsg = true;
      }
    }
    if(scopeType === 'Interstate'){
      this.origin$ = this.interStates$;
      this.destination$ = this.serviceAreas$;
    }
    if(scopeType === 'Intrastate'){
      this.origin$ = this.states$;
      this.destination$ = this.states$;
      this.showIntraMsg = true;
    }
    this.allOriginSelected = true;
    this.allDestinationSelected = true;
    this.originId = -1;
    this.destinationId = -1;
    this.setDisableBtnFlag();
  }

  scacChange(carrierId: any) {
    this.carrierIdList = (JSON.parse(JSON.stringify(this.hhgScopeReportForm.value)).scac);
    this.showIntlMsg = false;
    if(this.carrierIdList[0] === '-1'){
      this.carrierIdList = [];
      this.carrierList.forEach(c => this.carrierIdList.push(c.carrierId));
      this.allScacsSelected = true;
      
      if(this.scopeType === 'Intrastate'){
        this.showIntraMsg = true;
      }
    }
    else{
      this.allScacsSelected = false;
    }
    this.scacChanged = true;
    (this.originId && this.originId === -1) ? (this.allOriginSelected = true) : (this.allOriginSelected = false);
    (this.destinationId && this.destinationId === -1) ? (this.allDestinationSelected = true) : (this.allDestinationSelected = false);
    this.setDisableBtnFlag();
  }
  originChange(originId: any){
    originId ? (this.originId = +originId) : (this.originId = null);

    (this.originId && this.originId === -1) ? (this.allOriginSelected = true) : (this.allOriginSelected = false);
    
    if(this.scopeType === 'Intrastate'){
      this.destination$ = this.states$.pipe(map((results) => results.
            filter((state => state.stateCountryId == this.originId))));
      this.hhgScopeReportForm.get('destination').setValue('originId');
    }
    let originType;
    if(this.scopeType === 'International'){
       this.stateCountries$.pipe(map((results) => results.
          filter((state => state.stateCountryId == this.originId))))
          .subscribe(res => {originType = res[0].stateCountryType});
       if (originType === 'State'){
         this.destination$ = this.countries$;
       }
    }
    this.setDisableBtnFlag();
  }

  destinationChange(destinationId: any){
    destinationId ? (this.destinationId = +destinationId) : (this.destinationId = null);

    (this.destinationId && this.destinationId === -1) ? (this.allDestinationSelected = true) : 
                               (this.allDestinationSelected = false);
    this.setDisableBtnFlag();
  }
  setDisableBtnFlag(){
    this.disableBtn = false;
    this.showIntlMsg = false;
    if(!this.scopeTypeChanged){
      this.disableBtn = true;
      return;
    }
    if(!this.scacChanged){
      this.disableBtn = true;
      return;
    }
    if(this.allScacsSelected && this.allOriginSelected && 
       this.allDestinationSelected && (this.scopeType === 'International')){
      this.disableBtn = true;
      this.showIntlMsg = true;
      return;
    }
  }
  searchReports() {
    this.loader.show();
    this.hhgScopeService.getHhgScopeReportData(this.carrierIdList, this.scopeType,this.originId,this.destinationId).subscribe(res => {
      this.gridApi.setRowData(res);
      this.loader.hide();
    }, error => {
      this.loader.hide();
      this.alertService.error('Error while getting scope review data.');
    });
  }

 // Down load the HHG Scope Report by selected Scac's and Scope type.
  download() {
    let hhgrRatesResult: DownloadFileResponse;
    this.tmssloader.show();
    // this.buildData();
    console.log(this.carrierIdList);
    this.hhgScopeService.getHhgScopeReport(this.carrierIdList, this.scopeType,this.originId,this.destinationId).subscribe(
      (data: any) => {
        hhgrRatesResult = data as DownloadFileResponse;
        if (hhgrRatesResult != null) {
          const byteData: number[] = hhgrRatesResult.byteData;
          const fileName: string = hhgrRatesResult.fileName;
          const numRows: number = hhgrRatesResult.numberOfExcelRows;
          const bytes = new Uint8Array(byteData);
          const blob = new Blob([bytes], {
            type: null
          });

          console.log(numRows);
          FileSaver.saveAs(blob, fileName);
          this.alertService.success(hhg_scope_download_success);
        } else {
          this.alertService.warn('No Records found for the selected HHG Scope criteria.');
        }
        this.showExport = false;
        this.tmssloader.hide();
        setTimeout(() => {
          this.showExport = true;
        }, 5200);
      }, error => {
        this.alertService.error(api_error);
        this.tmssloader.hide();
      });
  }
}
